export default __webpack_public_path__ + "static/media/zunaira.fff0b0a7.png";